import { render, staticRenderFns } from "./OrganizersPage.vue?vue&type=template&id=03c25990&scoped=true&"
import script from "./OrganizersPage.vue?vue&type=script&lang=js&"
export * from "./OrganizersPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizersPage.vue?vue&type=style&index=0&id=03c25990&lang=scss&scoped=true&"
import style1 from "./OrganizersPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c25990",
  null
  
)

export default component.exports